import { createAsyncThunk } from '@reduxjs/toolkit'
import type { AsyncAction, PortalThunk } from '../../types'
import { portalAction } from '../../types'
import { resetAuthState } from './reducer'
import { ConsumerLogoutResponse } from '../../../model'
import { createFingerPrint } from '../../../utils'
import { navigateToShop } from '../../../utils/redirects'
import { setSessionStorageItem } from '@afterpay/utils/storage'

export enum UserAuthActions {
  USER_FINGERPRINT = 'user/fingerprint',
  AUTH_LOGOUT = 'consumer/logout',
}

export const createFingerprint = createAsyncThunk(UserAuthActions.USER_FINGERPRINT, async () => await createFingerPrint())

export const authLogout: PortalThunk<{ backToShop?: boolean }, ConsumerLogoutResponse | void> = portalAction(
  UserAuthActions.AUTH_LOGOUT,
  async (params, thunk) => {
    const logout: ConsumerLogoutResponse = await thunk.extra.portalApi().post('/portal/consumers/auth/logout', {})
    if (logout.status && params?.backToShop !== false) {
      navigateToShop()
    }
    return logout
  }
)

// TODO review this logout logic after registration/login is implemented
export const resetAuthData = (): AsyncAction<void> => async (dispatch) => {
  await dispatch(resetAuthState())
  setSessionStorageItem('profilingSessionId', null)
  setSessionStorageItem('transactionToken', null)
}
